const initialState = {
    error: null,
  };
  
  const loginReducer = (state = initialState, action) => {
    switch (action.type) {
      case 'USER_LOGIN_FAILURE':
        return {
          ...state,
          error: action.payload,
        };
        case 'CLEAR_LOGIN_ERROR':
            return {
              ...state,
              error: null,
            };
      default:
        return state;
    }
  };
  
  export default loginReducer;
  